import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

export default function LoadListListItemLinkSetLocation(props){
    return (
        <Link onClick={clickEvent} sx={{textDecoration:'none', cursor:'pointer'}}>
            <Box sx={{display:'flex'}}>
                <LocationOnOutlinedIcon />
                <Typography sx={{fontWeight:'bold', pl:'2px'}}>Set Location</Typography>
            </Box>
        </Link>
    )

    function clickEvent(e){
        let args ={
            idx:props.childIdx,
            mode: 6
        }
        props.openChildFx(args);
    }

}
